import { render, staticRenderFns } from "./testPaperList.vue?vue&type=template&id=00a9e050"
import script from "./testPaperList.vue?vue&type=script&lang=js"
export * from "./testPaperList.vue?vue&type=script&lang=js"
import style0 from "./testPaperList.vue?vue&type=style&index=0&id=00a9e050&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports